import { render, staticRenderFns } from "./PaymentBankSwiftEditModal.vue?vue&type=template&id=1dc4d527"
import script from "./PaymentBankSwiftEditModal.vue?vue&type=script&lang=js"
export * from "./PaymentBankSwiftEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports